import { useEffect } from 'react';
import { useUpdateSessionContext } from 'hooks/useUpdateSessionContext';
import { CustomerType } from 'gql/__generated/vp-apollo';
import { useNavigate } from 'react-router-dom';
import { useCustomerTypeSelectionForm } from './useCustomerTypeSelectionForm';

export const useCustomerTypeSelection = () => {
    const navigate = useNavigate();
    const { updateSessionContext, sessionContext, loading, error } = useUpdateSessionContext();
    const form = useCustomerTypeSelectionForm();

    useEffect(() => {
        if (sessionContext) {
            const { customerType } = sessionContext;
            if (customerType === CustomerType.Existing) {
                navigate('/bestandskunden');
            }
            if (customerType === CustomerType.New || customerType === CustomerType.ProviderChange) {
                navigate('/neukunden');
            }
        }
    }, [navigate, sessionContext]);

    return {
        updateCustomerType: updateSessionContext,
        loading,
        error,
        form,
    };
};
